/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.Vue = require('vue');


import './bulma';

import './script';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

/*---------General Commponents----------*/
import StickyHeader from './components/GeneralComponents/StickyHeader';
import VueLazyload from 'vue-lazyload';
import AddFav from './components/GeneralComponents/AddFav';


import MobileMenu from './components/GeneralComponents/MobileMenu';

import Collapse from './components/GeneralComponents/vue-bulma-collapse/Collapse'
import CollapseItem from './components/GeneralComponents/vue-bulma-collapse/Item'
import Slick from 'vue-slick'
import VueTranslate from 'vue-translate-plugin';
import VeeValidate from 'vee-validate';
import Tabs from './components/GeneralComponents/vue-tabs/Tabs';
import TabPane from './components/GeneralComponents/vue-tabs/TabPane';

import SearchModal from "./components/SearchModal";
import Messages from "./components/messages";
import NumberInput from '@chenfengyuan/vue-number-input';
import swiper from './components/swiper/swiper'
import swiperSlide from './components/swiper/slide.vue'
import Toasted from 'vue-toasted'
import VueSlideBar from './components/VueSlideBar'
import Loader from './components/LoadingBar'
import Uploader from './components/Uploader.vue';
/*--------- Site Components-------*/
import Newsletter from './components/SiteComponents/Newsletter'
import CategoryFilter from './components/SiteComponents/Category/CategoryFilter'
import SubCategoryProducts from './components/SiteComponents/Category/SubCategoryProducts'
import BrandFilter from './components/SiteComponents/Brands/BrandFilter'
import Offers from './components/SiteComponents/Offers/Index'
import Comments from './components/SiteComponents/Product/Comments';
import SearchResults from './components/SiteComponents/Search/SearchResults'
import OfferModal from './components/SiteComponents/Offers/OfferModal'
import OfferHeader from './components/SiteComponents/Offers/OfferHeader'
import ProductCard from './components/SiteComponents/Product/ProductCard'
import MegaMenu from './components/SiteComponents/MegaMenu'
import Orders from './components/Orders'
import SlotForm from './components/SlotForm'
import Register from './components/Register'
import Profile from './components/Profile'
import OfferFilter from './components/OfferFilter'
import Search from './components/Search'
import AddAddress from './components/AddAddress'
import UserAddress from './components/UserAddress'
import Cart from './components/Cart'
import VueWindowSize from 'vue-window-size';

Vue.component('add-fav', AddFav);

Vue.component('number-input', NumberInput);
Vue.component('tabs', Tabs);
Vue.component('tab', TabPane);
Vue.component('product-card', ProductCard);
Vue.component('collapse', Collapse);
Vue.component('collapse-item', CollapseItem);

Vue.use(VueWindowSize);
Vue.use(VueLazyload);

Vue.use(Toasted, {
    duration: 5000
});
Vue.use(VeeValidate);
Vue.use(VueTranslate);



/*---------------Lazyload ------------*/
Vue.use(VueLazyload, {
    preLoad: 100,
    error: '/front/img/illustrations/no_pictures.svg',
    loading: '/front/img/illustrations/loader.svg',
    attempt: 1,
    adapter: {
        loading(listender, Init) {
            listender.el.style.height = "4rem";
        },
        loaded({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
            el.style.height = "";
        },
    }
});
/*-----------Global Variables ----------*/
import translate from './components/SiteComponents/translation/general.json';
Vue.mixin({
    data: function() {
        return {
            translate: translate
        }
    },
    locales: translate,
})

export {
    Collapse,
    CollapseItem,
    Slick,
    SearchModal,
    swiper,
    swiperSlide,
    Messages,
    SlotForm,
    VueSlideBar,
    Loader,
    BrandFilter,
    CategoryFilter,
    Register,
    Profile,
    Newsletter,
    Comments,
    OfferFilter,
    Search,
    SearchResults,
    AddAddress,
    Offers,
    Cart,
    StickyHeader,
    MobileMenu,
    OfferModal,
    OfferHeader,
    Orders,
    MegaMenu,
    Uploader,
    SubCategoryProducts,
    UserAddress,

}
const app = new Vue({
    el: '#app',
    components: {
        Collapse,
        CollapseItem,
        Slick,
        SearchModal,
        swiper,
        swiperSlide,
        Messages,
        SlotForm,
        VueSlideBar,
        Loader,
        BrandFilter,
        CategoryFilter,
        Register,
        Profile,
        Newsletter,
        Comments,
        OfferFilter,
        Search,
        SearchResults,
        AddAddress,
        Offers,
        Cart,
        StickyHeader,
        MobileMenu,
        OfferModal,
        OfferHeader,
        Orders,
        MegaMenu,
        Uploader,
        SubCategoryProducts,
        UserAddress,
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/front/app.js